import { atomWithReset } from 'jotai/utils';

import { AnnounceOrganizationBusinessHourModal } from '~/state/partials/announce_organization_business_hour_modal/types';

export const announceOrganizationBusinessHourModalState =
  atomWithReset<AnnounceOrganizationBusinessHourModal>({
    afterLogin: false,
  });
